import { dasTokens } from '@dasa-health/alma-tokens'

export default {
    primary: {
        base: dasTokens.ColorBrandPrimary40,
        darken1: dasTokens.ColorBrandPrimary20,
        darken2: dasTokens.ColorBrandPrimary30,
        darken3: dasTokens.ColorBrandPrimary10,
        darken4: dasTokens.ColorNeutralInverseOnBrand10,
        lighten1: dasTokens.ColorBrandPrimary50,
        lighten2: dasTokens.ColorBrandPrimary60,
        lighten3: dasTokens.ColorBrandPrimary70,
        lighten4: dasTokens.ColorBrandPrimary80,
    },
    accent: {
        base: dasTokens.ColorInteractionAccent01,
        darken1: dasTokens.ColorInteractionAccent02,
        darken2: dasTokens.ColorInteractionAccent03,
    },
    error: {
        base: dasTokens.ColorFeedbackErrorText,
        lighten1: dasTokens.ColorFeedbackErrorShape,
        lighten4: dasTokens.ColorFeedbackInverseErrorShape,
        lighten5: dasTokens.ColorFeedbackInverseErrorText,
    },
    success: {
        base: dasTokens.ColorFeedbackSuccessText,
        lighten1: dasTokens.ColorFeedbackSuccessShape,
        lighten4: dasTokens.ColorFeedbackInverseSuccessShape,
        lighten5: dasTokens.ColorFeedbackInverseSuccessText,
    },
}
